import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.coupon';

const translations = {
    'coupon': 'Kuponok',
    'couponEdit': 'Kupon szerkesztése',
    'couponCreate': 'Új kupon',
    'edit.title': 'Kupon szerkesztése',

    'id.title': 'ID',
    'name.title': 'Megnevezés',
    'description.title': 'Leírás',
    'active_from.title': 'Aktív -tól',
    'active_to.title': 'Aktív -ig',
    'type.title': 'Típus',
    'applied_to.title': 'Mire érvényes',
    'is_free_shipping.title': 'Ingyenes szállítás',
    'is_active.title': 'Aktív',
    'usage_count.title': 'Hányszor használható fel',
    'is_combinable.title': 'Összevonható',
    'created_at.title': 'Létrehozva',
    'updated_at.title': 'Módosítva',
    'generated_codes_count.title': 'Generált kódok száma',
    'used_codes_count.title': 'Felhasznált kódok száma',
    'shipping_method_id.title': 'Szállítási mód',
    'payment_method_id.title': 'Fizetési mód',
    'coupon_code_attributes.title': 'Kódgenerálás',
    'price_ranges.title': 'Ársávok',

    'coupon_code_attributes.count.title': 'Darabszám',
    'coupon_code_attributes.length.title': 'Hossz',
    'coupon_code_attributes.type.title': 'Típus',
    'coupon_code_attributes.prefix.title': 'Prefix',
    'coupon_code_attributes.suffix.title': 'Suffix',
    'coupon_code_attributes.pattern.title': 'Pattern',

    'CouponAppliedTo.PRODUCT': 'Termék',
    'CouponAppliedTo.SHIPPING': 'Szállítás',

    'CouponType.PERCENT': 'Százalékos',
    'CouponType.VALUE': 'Fix összegű',

    'CouponCodeType.ALPHANUMERIC': 'Alfanumerikus',
    'CouponCodeType.LETTERS': 'Betűk',
    'CouponCodeType.NUMBERS': 'Számok',
    'CouponCodeType.SAFE_ALPHANUMERIC': 'Biztonságos alfanumerikus',

    'tabs.default': 'Alapadatok',
    'tabs.products': 'Termékek',
    'tabs.codes': 'Kuponkódok',

};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Coupon/lang/hu.ts